import { useEffect } from "react";
import { Button, Modal, Form, message } from "antd";
import Moment from "react-moment";
import postDataTrace from "../../../../services/postDataTrace";

export default function DeleteCustomer({ selected, isVisible, setVisible, refetch }: any) {
  const { source_name } = selected;

  const [form] = Form.useForm();

  useEffect(() => {}, [selected]);

  const onSubmit = async () => {
    const uri = `bookings/${selected?._id}/delete`;
    const data = { _id: selected?._id };

    const response = await postDataTrace(data, uri);

    if (response.success) {
      message.success("Deleted Successfully");
      refetch();
    }
    setVisible(false);
  };

  const hideModal = async () => {
    setVisible(false);
  };

  return (
    <Modal
      visible={isVisible}
      title="Delete Booking"
      onCancel={hideModal}
      footer={[
        <Button danger key="back" onClick={hideModal}>
          Cancel
        </Button>,
        <Button
          key="submit"
          form="DeleteBooking"
          htmlType="submit"
          type="primary"
          onSubmit={onSubmit}
          // loading={isLoading}
          danger
        >
          Delete
        </Button>,
      ]}
    >
      <Form id="DeleteBooking" form={form} onFinish={onSubmit}>
        <div>
          <p className="text-center font-bold">
            Are you sure you want to
            <span className="text-red-500 font-bold mx-1">delete</span>
            this booking
          </p>
          <div className="pb-4 flex flex-col justify-center items-center">
            <div className="flex text-black font-bold text-lg">
              VEHICLE: {selected?.title}
            </div>
            <div className="flex ">
              <span className="w-12">Date: </span>
              <Moment format="Do MMM, YYYY">{selected?.date}</Moment>
            </div>
            <div className="flex ">
              <span className="w-12">Time : </span>
              <Moment format="HH:mm A">{selected?.slottime?.starttime}</Moment>
              <div className="mx-2">-</div>
              <Moment format="HH:mm A">{selected?.slottime?.endtime}</Moment>
            </div>
            <div className="">Booking No. {selected?.bookingno}</div>
          </div>
          <span className="text-red-500 ml-1">{source_name}</span>
        </div>
      </Form>
    </Modal>
  );
}
